import { fmt } from 'components/IntlWrapper/IntlWrapper';

export const CURRENCY_OPTIONS = [
  {
    label: 'EGP',
    value: 'egp'
  },
  {
    label: 'USD',
    value: 'usd'
  }
];

export const PLAN_STATUS = {
  CANCELED: 'canceled',
  ACTIVE: 'active'
};

export const DASHBOARD = 'sllr';

export const PLAN_TIME_PREVIEW = {
  month: {
    value: 'month',
    label: fmt({ id: 'subscription.time_preview.month' })
  },
  year: {
    value: 'year',
    label: fmt({ id: 'subscription.time_preview.year' })
  }
};

export const PLAN_CANCEL_PAYLOAD = {
  type: 'postponed'
};

export const TIER_PLAN_MAPPING = {
  Bronze: 'A_M_F'
};

export const PAY_METHOD_TYPE = {
  CARD: 'card',
  LINK: 'link'
};

export const CONFIRM_PAYMENT_METHODS = {
  WALLET: {
    label: 'Wallet',
    value: 'WALLET'
  },
  ONLINE: {
    label: 'Online',
    value: 'ONLINE'
  }
};

export const CONFIRM_PAYMENT_METHODS_OPTIONS = ({ isWalletEnabled }) => {
  return [
    {
      label: fmt({
        id: 'subscription.confirm_modal.wallet'
      }),
      value: CONFIRM_PAYMENT_METHODS.WALLET.value,
      disabled: !isWalletEnabled,
      isRecommended: true,
      tooltip: fmt({
        id: 'subscription.confirm_modal.wallet_tooltip'
      }),
      disabled_text: fmt({
        id: 'subscription.confirm_modal.wallet_disabled_text'
      })
    },
    {
      label: fmt({
        id: 'subscription.confirm_modal.online'
      }),
      value: CONFIRM_PAYMENT_METHODS.ONLINE.value,
      disabled: false
    }
  ];
};

export const SUBSCRIPTION_ANNOUNCEMENT_PRICE = 199;

export const SUBSCRIPTION_ANNOUNCEMENT_CONTACT_NUMBER = '+201044568958';
